import React from 'react';

import {
  List,
} from '@mui/material';

import type { MilkJson } from '@/types/domain/milk/entities/milkEntity';

import CustomListItem from '@/components/CustomListItem';
import { MeasureDateTime } from '@/domain/milk/service/entity/valueObjects/measureDateTime';
import { Milk } from '@/domain/milk/service/entity/valueObjects/milk';
import { toStringDateTimeDisplay } from '@/utils/date';

const MilkInfo: React.FC<{
  /** データ */
  data: MilkJson,
}> = ({ data }) => {
  const {
    milk,
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name={MeasureDateTime.label}
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
      <CustomListItem
        name={Milk.label}
        content={milk.toString()}
      />
    </List>
  );
};

export default MilkInfo;
